<template>
  <div class="bodyDiv">
    <div class="header">
      <div class="headCenter Center1200">
        <div class="headCenter Center1200">
          <div class="logo">
            <img src="http://open.beijing.gov.cn/common/images/icon/opbj.png">
          </div>
          <div>北京商务服务发展地图</div>
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" style="margin-left: 20px;height: 59px">
            <el-menu-item index="1">国际化发展</el-menu-item>
            <el-menu-item index="2">北京市布局</el-menu-item>
          </el-menu>
        </div>
        <el-dropdown style="cursor:pointer;">
          <span class="el-dropdown-link" style="display: flex;align-items: center;">
            <el-avatar icon="el-icon-user-solid"></el-avatar>
            <p style="color: white;margin-left: 10px;">{{userName.account}}</p>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <span @click="handleClick('signOut')">安全退出</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span @click="handleClick('Back')">用户中心</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <nav class="headCenter Center1200">
      <img src="@/assets/ding.png" style="margin-right: 20px;">
      <Crumbs :Nav="JSON.stringify(Nav)"></Crumbs>
    </nav>
    <div class="context Center1200">
      <el-form :rules="rules" :model="form" ref="form" label-width="180px"  label-position="right">
        <el-form-item label="企业名称：" class="width45" prop="name">
          <el-input v-model="form.name" placeholder="请输入企业名称"></el-input>
        </el-form-item>

        <el-form-item label="行业类别：" class="width45" prop="industryType">
          <el-select v-model="form.industryType" placeholder="————请选择————">
            <el-option v-for="(item,Key) in categoryList" :key="Key" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属区域：" class="width45" prop="district">
          <el-select v-model="form.district" placeholder="————请选择————">
            <el-option v-for="(item,Key) in districtList" :key="Key" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="联系人：" class="width45" prop="contact">
          <el-input v-model="form.contact" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>

        <el-form-item label="联系方式：" class="width45" prop="contactNum">
          <el-input v-model="form.contactNum" placeholder="请输入联系方式"></el-input>
        </el-form-item>

        <el-form-item label="国家和地区：" class="width45" prop="entCountryCodes">
          <el-select v-model="form.entCountryCodes" filterable multiple placeholder="请选择业务覆盖的国家和地区">
            <el-option v-for="(item,Key) in entCountryCodeser" :key="Key" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="企业简介：" class="width90" prop="info">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" placeholder="请输入企业简介" v-model="form.info"></el-input>
        </el-form-item>

        <el-form-item label="主要业务：" class="width90" prop="business">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" placeholder="请输主要业务" v-model="form.business"></el-input>
        </el-form-item>

        <el-form-item label="典型案例：" class="width90" prop="typical">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" placeholder="请输入典型案例" v-model="form.typical"></el-input>
        </el-form-item>

        <el-form-item label="业务服务覆盖的国家和地区：" class="width90" prop="coverage">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" placeholder="请输入业务服务覆盖的国家和地区" v-model="form.coverage"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="$router.back(-1)">取消</el-button>
          <el-button v-if="!Flag" type="primary" @click="submitEntInfo()">提交</el-button>
          <el-button v-if="Flag" type="primary" @click="modifyInfoInfo()">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import {
  industriesApi,
  districtsApi,
  counterVyContinentIdApi,
  addEntInfoApi,
  modifyInfoInfoApi
  } from "@/api/ent/EntAdd";
import {infoApi} from "@/api/ent/EntInfo";
import Crumbs from '@/components/crumbs.vue';

export default {
  name: "EntAdd",
  components:{
    Crumbs
  },
  data() {
    return {
      Flag : false,
      userName: '',
      activeIndex: '1',
      Nav:[{//面包屑
        name:'国际化发展地图'
      },{
        name:'企业信息录入'
      }],
      form: {//表单提交需要的参数
        name: '',//企业名称
        industryType: '',//行业类别
        district: '',//所属区域
        contact: '',//联系人
        contactNum: '',//联系方式
        entCountryCodes:[],//国家和地区
        info: '',//企业简介
        business: '',//主要业务
        typical: '',//典型案例
        coverage: ''//业务服务覆盖的国家和地区
      },
      categoryList:[],//全部行业
      districtList:[],//北京地区
      entCountryCodeser:[],//全部国家
      rules: {
        name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        industryType: [
          { required: true, message: '请选择行业类别', trigger: 'change' }
        ],
        district: [
          { required: true, message: '请选择所属区域', trigger: 'change' }
        ],
        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactNum: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        entCountryCodes: [
          { type: 'array', required: true, message: '请至少选择一个国家和地区', trigger: 'change' }
        ],
        info: [
          { required: true, message: '请输入企业简介', trigger: 'blur' }
        ],
        business: [
          { required: true, message: '请输入主要业务', trigger: 'blur' }
        ],
        typical: [
          { required: true, message: '请输入典型案例', trigger: 'blur' }
        ],
        coverage: [
          { required: true, message: '业务服务覆盖的国家和地区', trigger: 'blur' }
        ]
      },
      Str: ''
    }
  },
  created(){
    if( this.$route.query.id != undefined) {
      infoApi({
        params:{
          entId:this.$route.query.id
        }
      }).then((res) => {//获取详情
        if (res.status == 200) {
          this.Flag = true;
          res.data.data.business = this.replaceAll(res.data.data.business, '<p>', '')
          res.data.data.business = this.replaceAll(res.data.data.business, '</p>', '')
          res.data.data.info = this.replaceAll(res.data.data.info, '<p>', '')
          res.data.data.info = this.replaceAll(res.data.data.info, '</p>', '')
          res.data.data.typical = this.replaceAll(res.data.data.typical, '<p>', '')
          res.data.data.typical = this.replaceAll(res.data.data.typical, '</p>', '')
          res.data.data.coverage = this.replaceAll(res.data.data.coverage, '<p>', '')
          res.data.data.coverage = this.replaceAll(res.data.data.coverage, '</p>', '')
          this.form = res.data.data
           this.$set(this.form, 'entCountryCodes', [])
          for (let i=0;i<res.data.data.entCountryInfoVoList.length;i++) {
            this.form.entCountryCodes.push(res.data.data.entCountryInfoVoList[i].countryCode)
          }
          delete this.form.entCountryInfoVoList;
          this.form.id = this.$route.query.id
          this.form.district = String(res.data.data.district)
          this.form.industryType = String(res.data.data.industryType)
        }
      });
    }
    this.userName = JSON.parse(sessionStorage.getItem('user'))
    industriesApi().then((res) => {//获取全部行业
      this.categoryList = res.data.data
    });
    districtsApi().then((res) => {//获取北京地区
      this.districtList = res.data.data
    });
    counterVyContinentIdApi().then((res) => {//获取全部国家
      this.entCountryCodeser = res.data.data
    });
  },
  methods: {
    replaceAll(StringVal, preVal, replaceVal) {
      return StringVal.replace(new RegExp(preVal,'g'), replaceVal)
    },
    handleClick(type){
      if(type == 'signOut'){
        sessionStorage.clear();
        window.location.href = '/web/userCenter/'
      }else{
        window.location.href = '/web/userCenter#/Usercenter'
      }
    },
    IphoneMessage(rule,value,cb){
      let Iphone = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if(Iphone.test(value)){
        return cb();
      }
      cb('请输入合法手机号/电话号');
    },
    submitEntInfo() {
      let that = this;
      let data = JSON.parse(JSON.stringify(that.form));
      this.$refs.form.validate((valid) => {
        if (valid) {
          data.info = that.SplitStr(data.info);
          data.business = that.SplitStr(data.business);
          data.typical = that.SplitStr(data.typical);
          data.coverage = that.SplitStr(data.coverage);
          addEntInfoApi(data).then((res) => {
            if(res.data.status == 200){
              this.$message({
                message: '添加数据成功',
                type: 'success'
              });
              setTimeout(function(){
                that.$router.push({path: '/ent/list',query:{}});
              },1000)
            }
          })
        }
      });
    },
    modifyInfoInfo() {
      let that = this;
      let data = JSON.parse(JSON.stringify(that.form));
      this.$refs.form.validate((valid) => {
        if (valid) {
          data.info = that.SplitStr(data.info);
          data.business = that.SplitStr(data.business);
          data.typical = that.SplitStr(data.typical);
          data.coverage = that.SplitStr(data.coverage);
          modifyInfoInfoApi(data).then((res) => {
            if(res.data.status == 200){
              this.$message({
                message: '添加数据成功',
                type: 'success'
              });
              setTimeout(function(){
                that.$router.push({path: '/ent/list',query:{}});
              },1000)
            }
          })
        }
      });
    },
    SplitStr(data){
      let Data = String(data).split('\n');
      this.Str  = '';
      for(let i=0;i<Data.length;i++){
        this.Str += '<p>'+ Data[i]+'</p>'
      }
      return this.Str;
    },
    handleSelect(val) {
      if(val == 1) {
        this.$router.push({path: '/ent/list',query:{}});
      } else{
        this.$router.push({path: '/bjent/list',query:{}});
      }
    }
  }
}
</script>

<style scoped>
  .el-menu-demo, .el-menu--horizontal, .el-menu {
    background: hsla(0,0%,100%,0)!important;
  }
  .el-menu--horizontal>.el-menu-item{
  padding: 0px 44px;
  font-size: 20px;
    height: 59px;
    line-height: 59px;
  }
  .el-menu-demo li {
    background: #BA0132 !important;
    color: white !important;
  }
  .el-menu-demo li:hover {
    background: #BA0132 !important;
  }
  .el-menu.el-menu--horizontal{
    border: none !important;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 1px solid white !important;
    background: #990012 !important;
  }
  .bodyDiv{
    /* background: rgb(240,221,223); */
    background: rgb(250,250,250);
  }
  .header{
    width: 100%;
    height: 60px;
    background: rgb(186,0,49);
  }
  .headCenter{
    height: 100%;
    display: flex;
    align-items: center;
    color: white;
    font-size: 24px;
    font-family: '方正正中黑简体';
  }
  .logo{
    width: 40px;
    height: 40px;
    display: flex;
    font-size: 14px;
    margin-right: 35px;
    border-radius: 4px;
    background: white;
    align-items: center;
    color: rgb(186,0,49);
    justify-content: center;
  }
  .logo img{
    width: 54px;
  }
  nav{
    height: 44px !important;
    border-bottom:  1px solid #DCDFE6;
    margin-bottom: 10px !important;
  }
  .Center1200{
    width: 1200px;
    margin: 0 auto;
  }
  .context{
    padding: 30px 0px;
    /* background: rgb(238,209,212); */
    background: white;
  }
  form{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  form .width45{
    width: 45%;
  }

  form .width90{
    width: 90%;
  }
  form .el-form-item__label{
    width: 100% !important;
  }
  .el-select{
    width: 100%;
  }
</style>
